import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { CredentialsService } from "./credentials.service";

@Injectable({
  providedIn: "root",
})
export class AuthenticationGuard {
  constructor(
    private router: Router,
    private credentialsService: CredentialsService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.credentialsService.isAuthenticated()) {
      return true;
    }

    this.router.navigate(["/login"], {
      queryParams: { redirect: state.url },
      replaceUrl: true,
    });

    return false;
  }
}
